/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Nested Investment PB / HPC service model payload.
 * 
 * @export
 * @interface ServiceModel
 */
export interface ServiceModel {
    /**
     * HPC / CRM product identifier for the service model.
     * @type {string}
     * @memberof ServiceModel
     */
    crmProductId?: string;
    /**
     * Display name of the investment product.
     * @type {string}
     * @memberof ServiceModel
     */
    productDisplayName?: string;
    /**
     * Engagement type code.
     * @type {string}
     * @memberof ServiceModel
     */
    engagementTypeCode?: string;
    /**
     * Resolved engagement type name.
     * @type {string}
     * @memberof ServiceModel
     */
    engagementTypeName?: string | null;
    /**
     * Service model code.
     * @type {string}
     * @memberof ServiceModel
     */
    serviceModelCode?: string;
    /**
     * Resolved service model name.
     * @type {string}
     * @memberof ServiceModel
     */
    serviceModelName?: string | null;
    /**
     * Product line code.
     * @type {string}
     * @memberof ServiceModel
     */
    productLineCode?: string;
    /**
     * Resolved product line name.
     * @type {string}
     * @memberof ServiceModel
     */
    productLineName?: string | null;
    /**
     * Reference currency code of the service model.
     * @type {string}
     * @memberof ServiceModel
     */
    currencyCode?: string;
    /**
     * Resolved currency name.
     * @type {string}
     * @memberof ServiceModel
     */
    currencyName?: string | null;
    /**
     * Investment strategy code.
     * @type {string}
     * @memberof ServiceModel
     */
    investmentStrategyCode?: string;
    /**
     * Resolved investment strategy name.
     * @type {string}
     * @memberof ServiceModel
     */
    investmentStrategyName?: string | null;
    /**
     * Product implementation code.
     * @type {string}
     * @memberof ServiceModel
     */
    productImplementationCode?: string;
    /**
     * Resolved product implementation name.
     * @type {string}
     * @memberof ServiceModel
     */
    productImplementationName?: string | null;
    /**
     * Transaction fee model code.
     * @type {string}
     * @memberof ServiceModel
     */
    transactionFeeModelCode?: string;
    /**
     * Resolved transaction fee model name.
     * @type {string}
     * @memberof ServiceModel
     */
    transactionFeeModelName?: string | null;
    /**
     * Banking service package code.
     * @type {string}
     * @memberof ServiceModel
     */
    bankingServicePackageCode?: string;
    /**
     * Resolved banking service package name.
     * @type {string}
     * @memberof ServiceModel
     */
    bankingServicePackageName?: string | null;
    /**
     * List price code.
     * @type {string}
     * @memberof ServiceModel
     */
    listPriceCode?: string;
    /**
     * service-model-linked contact note UUIDs.
     * 
     * @type {Array<string>}
     * @memberof ServiceModel
     */
    contactNoteIds?: Array<string>;
}

/**
 * Check if a given object implements the ServiceModel interface.
 */
export function instanceOfServiceModel(value: object): value is ServiceModel {
    return true;
}

export function ServiceModelFromJSON(json: any): ServiceModel {
    return ServiceModelFromJSONTyped(json, false);
}

export function ServiceModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceModel {
    if (json == null) {
        return json;
    }
    return {
        
        'crmProductId': json['crmProductId'] == null ? undefined : json['crmProductId'],
        'productDisplayName': json['productDisplayName'] == null ? undefined : json['productDisplayName'],
        'engagementTypeCode': json['engagementTypeCode'] == null ? undefined : json['engagementTypeCode'],
        'engagementTypeName': json['engagementTypeName'] == null ? undefined : json['engagementTypeName'],
        'serviceModelCode': json['serviceModelCode'] == null ? undefined : json['serviceModelCode'],
        'serviceModelName': json['serviceModelName'] == null ? undefined : json['serviceModelName'],
        'productLineCode': json['productLineCode'] == null ? undefined : json['productLineCode'],
        'productLineName': json['productLineName'] == null ? undefined : json['productLineName'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'currencyName': json['currencyName'] == null ? undefined : json['currencyName'],
        'investmentStrategyCode': json['investmentStrategyCode'] == null ? undefined : json['investmentStrategyCode'],
        'investmentStrategyName': json['investmentStrategyName'] == null ? undefined : json['investmentStrategyName'],
        'productImplementationCode': json['productImplementationCode'] == null ? undefined : json['productImplementationCode'],
        'productImplementationName': json['productImplementationName'] == null ? undefined : json['productImplementationName'],
        'transactionFeeModelCode': json['transactionFeeModelCode'] == null ? undefined : json['transactionFeeModelCode'],
        'transactionFeeModelName': json['transactionFeeModelName'] == null ? undefined : json['transactionFeeModelName'],
        'bankingServicePackageCode': json['bankingServicePackageCode'] == null ? undefined : json['bankingServicePackageCode'],
        'bankingServicePackageName': json['bankingServicePackageName'] == null ? undefined : json['bankingServicePackageName'],
        'listPriceCode': json['listPriceCode'] == null ? undefined : json['listPriceCode'],
        'contactNoteIds': json['contactNoteIds'] == null ? undefined : json['contactNoteIds'],
    };
}

export function ServiceModelToJSON(json: any): ServiceModel {
    return ServiceModelToJSONTyped(json, false);
}

export function ServiceModelToJSONTyped(value?: ServiceModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crmProductId': value['crmProductId'],
        'productDisplayName': value['productDisplayName'],
        'engagementTypeCode': value['engagementTypeCode'],
        'engagementTypeName': value['engagementTypeName'],
        'serviceModelCode': value['serviceModelCode'],
        'serviceModelName': value['serviceModelName'],
        'productLineCode': value['productLineCode'],
        'productLineName': value['productLineName'],
        'currencyCode': value['currencyCode'],
        'currencyName': value['currencyName'],
        'investmentStrategyCode': value['investmentStrategyCode'],
        'investmentStrategyName': value['investmentStrategyName'],
        'productImplementationCode': value['productImplementationCode'],
        'productImplementationName': value['productImplementationName'],
        'transactionFeeModelCode': value['transactionFeeModelCode'],
        'transactionFeeModelName': value['transactionFeeModelName'],
        'bankingServicePackageCode': value['bankingServicePackageCode'],
        'bankingServicePackageName': value['bankingServicePackageName'],
        'listPriceCode': value['listPriceCode'],
        'contactNoteIds': value['contactNoteIds'],
    };
}

